import { Flame, Waves, Mountain, MountainSnow } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { HazardType } from '../../services/fireDangerService';

export function getHazardIcon(hazardType: HazardType | null | undefined): LucideIcon {
  switch (hazardType) {
    case 'avalanche': return MountainSnow;
    case 'flood': return Waves;
    case 'landslide': return Mountain;
    default: return Flame;
  }
}

export function getHazardI18nKey(hazardType: HazardType): string {
  switch (hazardType) {
    case 'avalanche': return 'fire_danger.hazard.avalanche';
    case 'flood': return 'fire_danger.hazard.flood';
    case 'landslide': return 'fire_danger.hazard.landslide';
    default: return 'fire_danger.hazard.forest_fire';
  }
}
